import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import HttpBackend from "i18next-http-backend";

i18n
  .use(HttpBackend)
  .use(initReactI18next)
  .init({
    lng: "en",
    fallbackLng: "en",
    // fallbackLng: false,
    backend: {
      loadPath: "/locales/{{lng}}/translation.json", // Translation file path
    },
    debug: true,
    interpolation: {
      escapeValue: false,
    },
  });

i18n.on("failedLoading", (lng, ns, msg) => {
  console.error(
    `Failed to load language: ${lng}, namespace: ${ns}, error: ${msg}`
  );
  console.error(`Attempted to load: /locales/${lng}/translation.json`);
});

export default i18n;
